/* Mini ITA bag step after Add to cart on product cards.
   A bag card's Add to cart opens a small sheet: the bag, then Bag only / + sling / + wallet / both (assets/pb-bundle.js
   picker), one Add to cart and a plain "No thanks, just the bag". Close with the X, the scrim or Escape: nothing is added.
   Cards opt in with data-pb-pid on their product form; only products in the bundle config's eligible list (not the sling
   or wallet themselves) get the step. Everything else adds as before. */
(function () {
  'use strict';
  if (window.pbMiniUpsell) return;
  window.pbMiniUpsell = 1;
  var D = document, H = D.documentElement;
  function PB() { return window.PBBundle || null; }
  function store(n) { try { return window.Alpine && Alpine.store ? Alpine.store(n) : null; } catch (e) { return null; } }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  var CSS = '' +
    '.pbmu{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;visibility:hidden;pointer-events:none}' +
    '.pbmu.is-on{visibility:visible;pointer-events:auto}' +
    '.pbmu__scrim{position:absolute;inset:0;background:rgba(0,26,77,.38);opacity:0;transition:opacity .2s ease}' +
    '.pbmu.is-on .pbmu__scrim{opacity:1}' +
    '.pbmu__card{position:relative;width:100%;max-width:520px;max-height:88vh;max-height:88svh;overflow-y:auto;overscroll-behavior:contain;margin:0;padding:22px 18px calc(18px + env(safe-area-inset-bottom));border-radius:22px 22px 0 0;background:#fff;color:#003087;box-shadow:0 -10px 40px rgba(0,26,77,.18);opacity:0;transform:translateY(16px);transition:opacity .2s ease,transform .24s ease-out}' +
    '.pbmu.is-on .pbmu__card{opacity:1;transform:none}' +
    '@media (min-width:750px){.pbmu{align-items:center}.pbmu__card{margin:24px;border-radius:22px;padding:26px 24px 22px;max-height:calc(100vh - 48px)}}' +
    '.pbmu .pbmu__x{position:absolute!important;top:12px!important;right:12px!important;left:auto!important;z-index:2;display:grid!important;place-content:center;width:40px!important;height:40px!important;min-height:0!important;margin:0!important;padding:0!important;border:1px solid rgba(0,48,135,.18)!important;border-radius:999px!important;background:#fff!important;color:#003087!important;cursor:pointer;transition:transform .15s ease,opacity .15s ease}' +
    '.pbmu__x:hover{transform:translateY(-1px);opacity:.9}' +
    '.pbmu .pbmu__x svg{display:block!important;width:16px!important;height:16px!important;fill:none!important;stroke:#003087!important}' +
    '.pbmu__x:focus-visible,.pbmu__add:focus-visible,.pbmu__no:focus-visible{outline:2px solid #0034d3;outline-offset:2px}' +
    '.pbmu__bag{display:flex;align-items:center;gap:12px;margin:0 48px 16px 0;min-width:0}' +
    '.pbmu__bag img{flex:none;width:56px;height:56px;border-radius:12px;object-fit:contain;background:#fff;box-shadow:inset 0 0 0 1px rgba(0,48,135,.12)}' +
    '.pbmu__bag div{min-width:0}' +
    '.pbmu__ok{margin:0 0 2px;font:600 13px/1.3 var(--pb-font-ui,"Inter Tight",system-ui,sans-serif);color:#475583}' +
    '.pbmu__n{margin:0;font:400 20px/1.15 var(--pb-font-display,"Instrument Serif",Georgia,serif);color:#003087;overflow-wrap:anywhere}' +
    '.pbmu__pick{margin:0}' +
    '.pbmu__pick .pb-bndl{margin:0 0 14px}' +
    '.pbmu__acts{display:flex;flex-direction:column;gap:8px}' +
    '.pbmu .pbmu__add,.pbmu .pbmu__no{display:flex!important;align-items:center;justify-content:center;width:100%!important;min-height:52px!important;height:auto!important;margin:0!important;padding:0 20px!important;border-radius:999px!important;font:700 16px/1.2 var(--pb-font-ui,"Inter Tight",system-ui,sans-serif)!important;letter-spacing:.02em!important;text-transform:none!important;opacity:1;visibility:visible!important;cursor:pointer;transition:transform .15s ease,opacity .15s ease}' +
    '.pbmu .pbmu__add{border:0!important;background:#0034d3!important;color:#fff!important}' +
    '.pbmu .pbmu__no{border:1px solid rgba(0,48,135,.30)!important;background:#fff!important;color:#003087!important}' +
    '.pbmu .pbmu__no[hidden]{display:none!important}' +
    '.pbmu__add:hover,.pbmu__no:hover{transform:translateY(-1px);opacity:.92}' +
    '.pbmu__add[disabled]{opacity:.55;cursor:default;transform:none}' +
    '.pbmu__err{margin:10px 0 0;font:500 14px/1.4 var(--pb-font-ui,"Inter Tight",system-ui,sans-serif);color:#ad470e}' +
    '.pbmu__err[hidden]{display:none}' +
    'html.pbmu-lock,html.pbmu-lock body{overflow:hidden}' +
    '@media (prefers-reduced-motion:reduce){.pbmu__scrim,.pbmu__card{transition:none}}';

  var el = null, card, pick, addB, noB, errEl, nameEl, imgEl, S = null, bx = null, ctx = null, opener = null, busy = false;
  function build() {
    if (el) return;
    var st = D.createElement('style'); st.textContent = CSS; (D.head || H).appendChild(st);
    el = D.createElement('div'); el.className = 'pbmu'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="pbmu__scrim" data-pbmu-close></div>' +
      '<div class="pbmu__card" role="dialog" aria-modal="true" aria-labelledby="pbmu-n">' +
      '<button type="button" class="pbmu__x" data-pbmu-close aria-label="Close"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg></button>' +
      '<div class="pbmu__bag"><img alt="" decoding="async"><div><p class="pbmu__ok">Your bag</p><p class="pbmu__n" id="pbmu-n"></p></div></div>' +
      '<div class="pbmu__pick"></div>' +
      '<div class="pbmu__acts"><button type="button" class="pbmu__add">Add to cart</button><button type="button" class="pbmu__no">No thanks, just the bag</button></div>' +
      '<p class="pbmu__err" role="alert" hidden></p></div>';
    D.body.appendChild(el);
    card = el.querySelector('.pbmu__card'); pick = el.querySelector('.pbmu__pick'); addB = el.querySelector('.pbmu__add');
    noB = el.querySelector('.pbmu__no'); errEl = el.querySelector('.pbmu__err'); nameEl = el.querySelector('.pbmu__n'); imgEl = el.querySelector('.pbmu__bag img');
    [].forEach.call(el.querySelectorAll('[data-pbmu-close]'), function (b) { b.addEventListener('click', function () { close(); }); });
    addB.addEventListener('click', function () { add(S && S.opt !== 'none' ? S.items : []); });
    noB.addEventListener('click', function () { add([]); });
    D.addEventListener('keydown', function (e) {
      if (!el.classList.contains('is-on')) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = [].filter.call(card.querySelectorAll('button:not([disabled]),[href],[tabindex="0"]'), function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && D.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && D.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
  }
  function paintAdd() {
    if (busy) return;
    addB.textContent = S && S.opt !== 'none' ? 'Add the set to cart' : 'Add to cart';
    noB.hidden = !S || S.opt === 'none';
  }
  function lock(on) { H.classList.toggle('pbmu-lock', on); }
  function close() {
    if (!el || !el.classList.contains('is-on')) return;
    el.classList.remove('is-on'); el.setAttribute('aria-hidden', 'true');
    lock(false); busy = false;
    var o = opener; opener = null;
    if (o && o.isConnected) { try { o.focus({ preventScroll: true }); } catch (e) {} }
  }
  function open(c) {
    build(); ctx = c; busy = false; S = null;
    errEl.hidden = true; errEl.textContent = '';
    addB.disabled = false;
    nameEl.textContent = c.name; imgEl.src = c.img || ''; imgEl.hidden = !c.img;
    pick.innerHTML = '';
    var P = PB();
    /* M-9213: with the free wallet offer on for this bag, no paid 7" wallet options; the gift goes in with the add */
    var FW = window.PBFreeWallet; c.fw = !!(FW && FW.eligible && c.pid && FW.eligible(c.pid));
    bx = P.mount(pick, {
      opts: c.fw ? ['none', 'sling'] : undefined, labels: c.fw ? { none: 'Bag only, with the free wallet', sling: 'Add a 9" mini ITA sling' } : undefined,
      thumbs: true, head: 'Add mini ITA bags?', sub: 'Save an extra ' + P.maxPct() + '% on the set. Organise your bag, or carry them on their own.',
      bag: function () { return { name: c.name, price: c.price, compare: c.compare, qty: c.qty, elig: true, avail: true, img: c.img }; },
      onChange: function (s) { S = s; paintAdd(); }
    });
    if (bx && bx.state) S = bx.state();
    paintAdd();
    el.classList.add('is-on'); el.setAttribute('aria-hidden', 'false');
    lock(true);
    setTimeout(function () { var f = pick.querySelector('[aria-checked="true"]') || addB; try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }

  function add(extra) {
    if (busy || !ctx) return;
    busy = true; addB.disabled = true; addB.textContent = 'Adding';
    var items = [{ id: ctx.vid, quantity: ctx.qty }].concat(extra || []);
    if (ctx.fw && window.PBFreeWallet) items = window.PBFreeWallet.withGift(items, ctx.pid, ctx.title);
    var body = { items: items };
    try { var ch = store('xCartHelper'); if (ch && ch.getSectionsToRender) { body.sections = ch.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; } } catch (e) {}
    fetch(root().replace(/\/?$/, '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var er = new Error(j && (j.description || j.message) || 'HTTP ' + r.status); er.status = r.status; throw er; } return j; }); })
      .then(function (data) {
        close();
        var done = false;
        try {
          var ch2 = store('xCartHelper'), mc = store('xMiniCart');
          if (data && data.sections && ch2 && ch2.reRenderSections) { ch2.reRenderSections(data.sections); if (mc) { mc.needReload = false; mc.openCart(); } done = true; }
          if (!done && mc) { mc.needReload = true; if (mc.reLoad) mc.reLoad(); mc.openCart(); done = true; }
        } catch (e) {}
        if (!done) { location.href = root().replace(/\/?$/, '/') + 'cart'; return; }
        try { D.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); } catch (e) {}
        fetch(root().replace(/\/?$/, '/') + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
          .then(function (c) { if (window.pbCartCount) window.pbCartCount.set(c.item_count); var ch3 = store('xCartHelper'); if (ch3) ch3.currentItemCount = c.item_count; }).catch(function () {});
      })
      .catch(function (err) {
        busy = false; addB.disabled = false; paintAdd();
        errEl.textContent = err && err.status === 422 ? (err.message || 'All the stock of this item is already in your cart.') : 'Could not add to cart. Please try again.';
        errEl.hidden = false;
      });
  }

  /* bag details for the sheet: the card's product JSON (one request per handle) */
  var cache = {};
  function product(handle) {
    if (!cache[handle]) cache[handle] = fetch(root().replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    cache[handle].catch(function () { delete cache[handle]; });
    return cache[handle];
  }
  function img(src, w) { if (!src) return ''; src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  var pass = false;
  D.addEventListener('click', function (e) {
    if (pass) return;
    var b = e.target && e.target.closest ? e.target.closest('button[type="submit"][name="add"]') : null;
    if (!b || b.disabled) return;
    var f = b.form || b.closest('form'), pid = f && f.getAttribute('data-pb-pid');
    var P = PB(); if (!pid || !P) return;
    var c = P.cfg();
    if (!P.eligible(pid) || String(pid) === String(c.sling && c.sling.id) || String(pid) === String(c.wallet && c.wallet.id)) return;
    var vin = f.querySelector('input[name="id"]'), vid = vin && +vin.value, handle = f.getAttribute('data-pb-handle');
    if (!vid || !handle) return;
    e.preventDefault(); e.stopImmediatePropagation();
    opener = b;
    var qin = f.querySelector('input[name="quantity"]'), qty = Math.max(1, parseInt(qin && qin.value, 10) || 1);
    product(handle).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.id === vid; })[0] || p.variants[0];
      var fi = v && v.featured_image ? v.featured_image.src : p.featured_image;
      var nm = P.shortName(p.id, p.title);
      if (v && v.title && v.title !== 'Default Title') nm += ', ' + v.title;
      open({ vid: v.id, qty: qty, price: v.price, compare: v.compare_at_price || 0, name: nm, img: img(fi, 160), pid: p.id, title: p.title });
    }).catch(function () {
      /* no product data: the card adds the bag the usual way */
      pass = true; try { b.click(); } finally { pass = false; }
    });
  }, true);
})();
